// Generic "working…" screen, reused for three phases (loading ticket types,
// creating the order, confirming the payment). Inside the shell so the step
// indicator and branding stay put through the transition.

import { KioskShell } from "../components/KioskShell";
import { ProgressBar } from "../components/ProgressBar";
import { useLang } from "../i18n/LangContext";
import type { StringKey } from "../i18n/strings";

export type LoadingKind = "tickets" | "order" | "confirm";

const CONFIG: Record<LoadingKind, { messageKey: StringKey; step: number }> = {
  tickets: { messageKey: "loadingTicketTypes", step: 1 },
  order: { messageKey: "loadingCreatingOrder", step: 3 },
  confirm: { messageKey: "loadingConfirming", step: 3 },
};

const SKELETON_ROWS = ["sk-a", "sk-b", "sk-c"];

export function LoadingScreen({ kind }: { kind: LoadingKind }) {
  const { t } = useLang();
  const { messageKey, step } = CONFIG[kind];
  return (
    <KioskShell step={step}>
      <div className="screen screen--center">
        <ProgressBar />
        <p className="screen__subtitle">{t(messageKey)}</p>
        {kind === "tickets" ? (
          <div aria-hidden="true" className="ticket-list">
            {SKELETON_ROWS.map((id) => (
              <div className="skeleton skeleton--card" key={id} />
            ))}
          </div>
        ) : null}
      </div>
    </KioskShell>
  );
}
